import { CardMetadata, CardCategory, CardType } from '@/components/GiftCardForm/GiftCardForm'

export const convertSanityGiftCardFaceplateToCardMetadata = (
  faceplate: SanityGiftCardFaceplate,
  cardType: CardType,
): CardMetadata => {
  return {
    id: faceplate._id,
    cardType,
    faceplateCode: faceplate.faceplateCode,
    image: { ...faceplate.image, alt: faceplate.altText },
  }
}

const isFaceplateAvailableForCardType = (
  faceplate: SanityGiftCardFaceplate,
  cardType: CardType,
): boolean => {
  const availability =
    cardType === 'physical' ? faceplate.physicalCardAvailability : faceplate.digitalCardAvailability

  if (availability === 'isUnavailable') return false
  if (availability === 'isAvailable') return true

  const dateRange =
    cardType === 'physical' ? faceplate.temporaryPhysicalDateRange : faceplate.temporaryDigitalDateRange

  if (!dateRange) return true

  const now = new Date()
  const startDate = new Date(dateRange.startDate)
  const endDate = new Date(dateRange.endDate)
  endDate.setTime(endDate.getTime() + 24 * 60 * 60 * 1000 - 1)

  return now >= startDate && now <= endDate
}

export const getCuratedAvailableCategories = (
  curated: SanityGiftCardGridCategory[],
  cardType: CardType,
  regionCode: string,
): CardCategory[] => {
  return curated
    .filter(entry => entry?.category)
    .map(({ category, cards }) => ({
      id: category._id,
      title: category.title,
      cards: (cards ?? [])
        .filter((card): card is SanityGiftCardFaceplate => Boolean(card))
        .filter(card => card.enabledRegions?.includes(regionCode))
        .filter(card => isFaceplateAvailableForCardType(card, cardType))
        .map(card => convertSanityGiftCardFaceplateToCardMetadata(card, cardType)),
    }))
    .filter(category => category.cards.length > 0)
}
